import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const LabelBarChart = ({
    XdataKey = "name",
    barDatas = [
        {
            dataKey: "pv",
            fill: "#8884d8"
        },
        {
            dataKey: "uv",
            fill: "#82ca9d"
        },
    ],
    barChartDatas = [
        {
            name: 'Page A',
            uv: 40,
            pv: 23
        },
        {
            name: 'Page B',
            uv: 30,
            pv: 23

        },
        {
            name: 'Page C',
            uv: 20,
            pv: 23

        },
        {
            name: 'Page D',
            uv: 27,
            pv: 23

        },
        {
            name: 'Page E',
            uv: 18,
            pv: 23

        },
        {
            name: 'Page F',
            uv: 23,
            pv: 23

        },
        {
            name: 'Page G',
            uv: 34,
            pv: 23

        },
    ]
}) => {

    return (
        <ResponsiveContainer
            width="100%"
            height="100%"
        >
            <BarChart
                data={barChartDatas}
                margin={{
                    top: 20,
                    right: 30,
                    left: 0,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey={XdataKey}
                />
                <YAxis />
                <Tooltip />
                <Legend
                    align='right'
                    iconType="circle"
                />
                {
                    barDatas.map((value) => {
                        return <Bar dataKey={value?.dataKey} stackId="a" fill={value?.fill} />

                    })
                }
            </BarChart>
        </ResponsiveContainer>
    )
}

export default LabelBarChart
